import { Spinner } from "flowbite-react";
import { AmplitudeHeader } from "./AmplitudeHeader";
import { AmplitudeCredentialsForm } from "./AmplitudeCredentialsForm";
import { UsageMetricsForm } from "../shared/UsageMetricsForm";
import { useIntegrations } from "../../../../contexts/IntegrationsContext";
import { useState, useEffect } from "react";

export const AmplitudeIntegration = () => {
  const { loading, isIntegrationConnected, getIntegrationById } =
    useIntegrations();

  // Credentials state for pre-connection
  const [credentials, setCredentials] = useState({
    api_key: "",
    secret_key: "",
    region: "US",
  });

  const isConnected = isIntegrationConnected("amplitude");
  const integration = getIntegrationById("amplitude");

  // Clear credentials after successful connection
  useEffect(() => {
    if (isConnected) {
      setCredentials({ api_key: "", secret_key: "", region: "US" });
    }
  }, [isConnected]);

  if (loading) {
    return (
      <div className="flex h-48 items-center justify-center">
        <Spinner size="lg" aria-label="Loading Amplitude integration" />
      </div>
    );
  }

  return (
    <div className="flex min-h-full flex-1 flex-col gap-4">
      <div className="animation-slide-up-lil-bounce mt-1 flex w-full flex-col gap-4 overflow-x-auto rounded-lg bg-white py-4 shadow">
        <AmplitudeHeader
          isConnected={isConnected}
          integration={integration}
          credentials={credentials}
        />

        {!isConnected && (
          <>
            <hr className="border-gray-200" />
            <AmplitudeCredentialsForm
              credentials={credentials}
              onCredentialsChange={setCredentials}
            />
          </>
        )}

        {isConnected && (
          <>
            <hr className="border-gray-200" />
            <UsageMetricsForm
              integration={integration}
              providerName="Amplitude"
            />
          </>
        )}
      </div>
    </div>
  );
};
